module.exports = __webpack_public_path__ + "img/dashboard.675620d8.svg";